// Customer-specific landing pages.
// To add a new customer, just add a new entry below — accessible at:
//   https://hebrewinscriptions.com/<slug>
//
// Keep slugs lowercase, no spaces.
export const customers = {
  browardmonuments: {
    name: 'Broward Monuments',
    // Optional fields for future customisation:
    // tagline: 'Crafted for the Broward community',
    // accentColor: '#B4975A',
  },
};

export const getCustomer = (slug) => {
  if (!slug) return null;
  return customers[slug.toLowerCase()] || null;
};
